module.exports = __webpack_public_path__ + "static/media/03-06.76e83ec2.png";